import { PageDecorated } from 'pages/page';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ContentBox } from 'components/content-box';
import { downloadVideoSelector } from 'common/selectors/custom';
import { fetchDownloadVideoRequestAction } from 'common/actions';
import { LoadingSpinner } from 'components/loading-spinner';
import { ErrorHandleEnum } from 'components/error-handle/enum';
import { Error404Page, Error500Page } from 'pages/error.pages';
import { errorSelector } from 'components/error-handle/selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

const UitArchiveDownloadPage = ({ downloadVideo, fetchDownloadVideo, error }) => {
  if (error.errorType === ErrorHandleEnum.UIT_REGULAR_DOWNLOAD_PAGE) {
    if (error.errorStatus === 404) {
      return <Error404Page />;
    }
    if (error.errorStatus === 500) {
      return <Error500Page error={error} />;
    }
  }

  if (!downloadVideo) {
    fetchDownloadVideo();
    return (
      <PageDecorated>
        <LoadingSpinner />
      </PageDecorated>
    );
  }

  return (
    <PageDecorated>
      <ContentBox className="ct-uit-download-page">
        <h1>Downloadseite</h1>
        <p>
          Unter dem unten stehenden Link können Sie den von Ihnen angeforderten Film als Datei herunterladen. Diese
          Datei ist lediglich zur Archivierung in Ihrer Bank vorgesehen. Zum Einsatz im Internet empfehlen wir Ihnen
          dringend die Nutzung des ebenfalls an Sie versandten HTML-Embed-Codes beziehungsweise Links. Diese werden
          aktualisiert, wenn eine neue Version des Films vorliegt. So ist sichergestellt, dass Sie immer die aktuellste
          Version nutzen.
        </p>

        <table className="ct-uit-download-page__table">
          <thead className="ct-uit-download-page__table-header">
            <tr>
              <th>Datei</th>
            </tr>
          </thead>
          <tbody>
            {downloadVideo &&
              downloadVideo.format
                .filter((video) => video.quality === '360p')
                .filter((video) => video.type === 'mp4')
                .map((video) => {
                  return (
                    <tr>
                      <td>
                        <a href={video.link} target="_blank" rel="noreferrer noopener">
                          {downloadVideo.title}
                        </a>
                      </td>
                    </tr>
                  );
                })[0]}
            <tr>
              <td className="ct-uit-download-page__table__note">
                <FontAwesomeIcon className="ct-uit-download-page__table__note__icon" icon={faInfoCircle} />
                <span className="ct-uit-download-page__table__note__text">
                  Zum Herunterladen klicken Sie mit der rechten Maustaste auf die Datei und wählen Sie die Option "Ziel
                  speichern unter...".
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </ContentBox>
    </PageDecorated>
  );
};

export const UitArchiveDownloadPageDecorated = compose(
  withRouter,
  connect(
    (state) => ({
      downloadVideo: downloadVideoSelector(state),
      error: errorSelector(state),
    }),
    (dispatch, props) => ({
      fetchDownloadVideo: () => dispatch(fetchDownloadVideoRequestAction(props.match.params.videoId)),
    })
  )
)(UitArchiveDownloadPage);
